import { render, staticRenderFns } from "./LegacyBeginOrderView.vue?vue&type=template&id=a28ef946&"
import script from "./LegacyBeginOrderView.vue?vue&type=script&lang=js&"
export * from "./LegacyBeginOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports